/**
 * DENET — announcement bar rotator.
 * Loaded only when the section has more than one message.
 */
import { DenetElement, define, media } from '@denet/core';

class DnAnnouncementBar extends DenetElement {
  /** @type {number | undefined} */
  #timer;
  #index = 0;

  mounted() {
    if (this.dataset.rotate !== 'true') return;

    /** @type {HTMLElement[]} */
    this.items = /** @type {HTMLElement[]} */ (
      Array.from(this.querySelectorAll('[data-ref="item"]'))
    );
    if (this.items.length < 2) return;

    const interval = Number(this.dataset.interval) || 5000;
    this.#timer = window.setInterval(() => this.#advance(), interval);

    // Pausing on hover keeps a message readable while it is being read.
    if (media.pointerFine) {
      this.addEventListener('pointerenter', () => this.#pause(), { signal: this.signal });
      this.addEventListener('pointerleave', () => this.#resume(interval), { signal: this.signal });
    }

    document.addEventListener(
      'visibilitychange',
      () => (document.hidden ? this.#pause() : this.#resume(interval)),
      { signal: this.signal }
    );
  }

  unmounted() {
    this.#pause();
  }

  #advance() {
    this.items[this.#index]?.classList.remove('is-active');
    this.#index = (this.#index + 1) % this.items.length;
    this.items[this.#index]?.classList.add('is-active');
  }

  #pause() {
    window.clearInterval(this.#timer);
  }

  #resume(interval) {
    this.#pause();
    this.#timer = window.setInterval(() => this.#advance(), interval);
  }
}

define('dn-announcement-bar', DnAnnouncementBar);
